import { FunctionComponent } from 'react';

import { useIsAssemblyBrandEnabled } from 'src/hooks/useIsAssemblyBrandEnabled';

import { AssemblyAvatar } from './AssemblyAvatar';
import { CopilotAvatar } from './CopilotAvatar';

export const BrandAvatar: FunctionComponent = () => {
  const { isAssemblyBrandEnabled } = useIsAssemblyBrandEnabled();
  return isAssemblyBrandEnabled ? <AssemblyAvatar /> : <CopilotAvatar />;
};
